"use client";

import dreamnClock from "@/assets/images/dreamn-clock.svg";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";

const CLOCK_MASK_STYLE = (src) => ({
  backgroundColor: "currentColor",
  maskImage: `url(${src})`,
  WebkitMaskImage: `url(${src})`,
  maskSize: "contain",
  maskRepeat: "no-repeat",
  maskPosition: "center",
  WebkitMaskSize: "contain",
  WebkitMaskRepeat: "no-repeat",
  WebkitMaskPosition: "center",
});

export default function DreamnMatchTime({
  time,
  statusLabel,
  openOtherOdds,
  onOtherOddsClick,
  showOtherOddsButton = false,
  halfTimeScore = "",
}) {
  const htLine =
    halfTimeScore != null && String(halfTimeScore).trim() !== ""
      ? `HT(${String(halfTimeScore).trim()})`
      : null;

  const otherBetsEnabled = Boolean(showOtherOddsButton);

  return (
    <div className="kbv-dreamn-match-time grid w-full min-w-0 grid-cols-[max-content_minmax(0,1fr)_auto] items-center gap-x-1 gap-y-0.5">
      <div className="time-col-1 kbv-time-col-1 flex w-max max-w-none shrink-0 flex-row flex-nowrap items-center gap-1 pl-1 md:gap-1.5">
        <span
          className="inline-block h-3.5 w-3.5 md:h-4 md:w-4 shrink-0 kbv-time-muted-navy-slate"
          style={CLOCK_MASK_STYLE(dreamnClock)}
          aria-hidden
        />
        <span className="shrink-0 text-xs font-medium font-bold whitespace-nowrap kbv-time-muted-navy-slate md:text-sm">
          {time}
        </span>
        {htLine ? (
          <span className="shrink-0 text-xs font-bold leading-none text-[var(--theme-text)] tabular-nums whitespace-nowrap md:text-sm">
            {htLine}
          </span>
        ) : null}
      </div>

      <div className="kbv-time-status-col flex min-h-0 min-w-0 flex-row items-center justify-center px-0.5 md:gap-4">
        <div className="middle flex min-h-0 min-w-0 w-full max-w-full items-center justify-center self-center text-center text-xs font-bold uppercase leading-tight kbv-status-live-navy-slate md:text-sm mr-6 md:mr-7">
          {statusLabel}
        </div>
      </div>

      <div className="kbv-time-other-bets flex shrink-0 items-center justify-self-end justify-end">
        <button
          type="button"
          disabled={!otherBetsEnabled}
          onClick={onOtherOddsClick}
          aria-disabled={!otherBetsEnabled}
          title={otherBetsEnabled ? undefined : "Trận này không có thêm kèo khác"}
          className="kbv-time-other-bets-btn inline-flex max-w-[min(100%,9rem)] items-center gap-0.5 border-0 bg-transparent p-0 text-left text-xs font-semibold text-[var(--theme-primary)] underline-offset-2 hover:underline enabled:cursor-pointer disabled:cursor-not-allowed disabled:opacity-45 disabled:hover:no-underline md:max-w-none md:text-sm"
        >
          <span className="min-w-0 truncate">Kèo khác</span>
          <img
            src={ICON_ARROW_UP}
            alt=""
            width={14}
            height={14}
            className={`shrink-0 transition-transform duration-300 ${openOtherOdds && otherBetsEnabled ? "rotate-180" : "rotate-0"}`}
          />
        </button>
      </div>
    </div>
  );
}
